import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, Clock, Users, ArrowLeft, Send } from 'lucide-react';

const JobDetails = () => {
  const { id } = useParams();

  const jobDetails = {
    1: {
      title: 'Senior AI/ML Engineer',
      department: 'Engineering',
      location: 'Kuala Lumpur, Malaysia',
      type: 'Full-time',
      experience: '5+ years',
      salary: '$80,000 - $120,000',
      description: 'Join our AI/ML team to develop cutting-edge artificial intelligence solutions for enterprise clients. You will work on machine learning models, deep learning algorithms, and AI-powered applications that transform businesses across various industries.',
      responsibilities: [
        'Design and implement machine learning models and algorithms',
        'Develop AI-powered applications and solutions',
        'Collaborate with cross-functional teams to integrate AI capabilities',
        'Optimize model performance and scalability',
        'Research and implement latest AI/ML technologies',
        'Mentor junior engineers and provide technical guidance'
      ],
      requirements: [
        'Master\'s degree in Computer Science, AI, or related field',
        '5+ years of experience in AI/ML development',
        'Proficiency in Python, TensorFlow, PyTorch',
        'Experience with cloud platforms (AWS, Azure, GCP)',
        'Strong understanding of MLOps and model deployment',
        'Experience with big data technologies (Spark, Hadoop)',
        'Excellent problem-solving and analytical skills'
      ],
      benefits: [
        'Competitive salary and performance bonuses',
        'Comprehensive health and dental insurance',
        'Flexible working arrangements and remote work options',
        'Professional development and training opportunities',
        'Stock options and equity participation',
        'Generous vacation and leave policies',
        'State-of-the-art technology and equipment'
      ],
      posted: '2 days ago'
    }
  };

  const job = jobDetails[id] || jobDetails[1]; // Fallback to first job if ID not found

  return (
    <div className="job-details-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/careers" className="back-link">
            <ArrowLeft size={16} />
            Back to Careers
          </Link>

          <div className="job-details-header">
            <div className="job-title-section">
              <h1>{job.title}</h1>
              <span className="job-department">{job.department}</span>
            </div>
            
            <div className="job-meta-details">
              <div className="meta-item">
                <MapPin size={18} />
                <span>{job.location}</span>
              </div>
              <div className="meta-item">
                <Clock size={18} />
                <span>{job.type}</span>
              </div>
              <div className="meta-item">
                <Users size={18} />
                <span>{job.experience}</span>
              </div>
            </div>

            <div className="salary-range">
              <strong>Salary: {job.salary}</strong>
            </div>
          </div>

          <div className="job-content">
            <div className="job-main-content">
              <section className="job-section">
                <h2>About This Role</h2>
                <p>{job.description}</p>
              </section>

              <section className="job-section">
                <h2>Key Responsibilities</h2>
                <ul className="job-list">
                  {job.responsibilities.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>

              <section className="job-section">
                <h2>Requirements</h2>
                <ul className="job-list">
                  {job.requirements.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>

              <section className="job-section">
                <h2>Benefits & Perks</h2>
                <ul className="job-list">
                  {job.benefits.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>
            </div>

            <div className="job-sidebar">
              <div className="apply-card">
                <h3>Ready to Apply?</h3>
                <p>Join our team and make an impact on a global scale.</p>
                <button className="apply-button">
                  <Send size={16} />
                  Apply Now
                </button>
                <p className="apply-note">
                  Applications are reviewed within 48 hours
                </p>
              </div>

              <div className="job-info-card">
                <h4>Job Information</h4>
                <div className="info-item">
                  <strong>Posted:</strong> {job.posted}
                </div>
                <div className="info-item">
                  <strong>Department:</strong> {job.department}
                </div>
                <div className="info-item">
                  <strong>Employment Type:</strong> {job.type}
                </div>
                <div className="info-item">
                  <strong>Experience Level:</strong> {job.experience}
                </div>
              </div>

              <div className="share-card">
                <h4>Share This Job</h4>
                <div className="share-buttons">
                  <button className="share-btn linkedin">LinkedIn</button>
                  <button className="share-btn twitter">Twitter</button>
                  <button className="share-btn email">Email</button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default JobDetails;